export default {
  // Tiêu đề trang
  'adsMccAccount.title': 'Cài đặt tài khoản MCC',

  // Trường tìm kiếm
  'adsMccAccount.platform': 'Nền tảng quảng cáo',
  'adsMccAccount.mccName': 'Tên MCC',

  // Nút
  'adsMccAccount.search': 'Tìm kiếm',
  'adsMccAccount.reset': 'Đặt lại',
  'adsMccAccount.add': 'Thêm',
  'adsMccAccount.delete': 'Xóa',

  // Cột bảng
  'adsMccAccount.serial': 'Số thứ tự',
  'adsMccAccount.platform': 'Nền tảng quảng cáo',
  'adsMccAccount.mccName': 'Tên MCC',
  'adsMccAccount.apiToken': 'Token API Developer',
  'adsMccAccount.clientId': 'OAuth Client ID',
  'adsMccAccount.clientSecret': 'OAuth Client Secret',
  'adsMccAccount.refreshToken': 'Refresh Token',
  'adsMccAccount.authStatus': 'Trạng thái ủy quyền',
  'adsMccAccount.action': 'Hành động',

  // Trạng thái ủy quyền
  'adsMccAccount.authorized': 'Đã ủy quyền',
  'adsMccAccount.unauthorized': 'Chưa ủy quyền',

  // Xác thực biểu mẫu
  'adsMccAccount.platformRequired': 'Vui lòng chọn nền tảng quảng cáo',
  'adsMccAccount.mccNameRequired': 'Vui lòng nhập tên MCC',
  'adsMccAccount.apiTokenRequired': 'Vui lòng nhập token API developer',
  'adsMccAccount.clientIdRequired': 'Vui lòng nhập OAuth Client ID',
  'adsMccAccount.clientSecretRequired': 'Vui lòng nhập OAuth Client Secret',
  'adsMccAccount.refreshTokenRequired': 'Vui lòng nhập Refresh Token',

  // Placeholder biểu mẫu
  'adsMccAccount.mccNamePlaceholder': 'Tên MCC tùy chỉnh',
  'adsMccAccount.apiTokenRequired': 'Vui lòng nhập token API developer',
  'adsMccAccount.clientIdRequired': 'Vui lòng nhập OAuth Client ID',
  'adsMccAccount.clientSecretRequired': 'Vui lòng nhập OAuth Client Secret',
  'adsMccAccount.refreshTokenPlaceholder': 'Vui lòng nhấp vào nút bên dưới để lấy',
  'adsMccAccount.getRefreshToken': 'Lấy Refresh Token',
  'adsMccAccount.getRefreshTokenInfo': 'Đang lấy refresh token...',
  'adsMccAccount.validationError': 'Vui lòng điền tất cả các trường bắt buộc',
  'adsMccAccount.save': 'Lưu',
  'adsMccAccount.cancel': 'Hủy',
  'adsMccAccount.fetchDataFailed': 'Không thể tải dữ liệu',
  'adsMccAccount.fetchTypesFailed': 'Không thể tải loại nền tảng quảng cáo',
  'adsMccAccount.noData': 'Không có dữ liệu',

  // Tiêu đề modal
  'adsMccAccount.addMccAccount': 'Thêm tài khoản MCC',

  // Thông báo
  'adsMccAccount.addSuccess': 'Thêm thành công',
  'adsMccAccount.addFailed': 'Thêm thất bại',
  'adsMccAccount.deleteSuccess': 'Xóa thành công',
  'adsMccAccount.deleteFailed': 'Xóa thất bại',
  'adsMccAccount.confirmDelete': 'Bạn có chắc chắn muốn xóa bản ghi này không?',

  // Phân trang
  'adsMccAccount.totalRecords': 'Tổng cộng {total} bản ghi',
  'adsMccAccount.pagination': 'Trang {current} của {page}, Tổng cộng {total} bản ghi',
};
